module.exports = __webpack_public_path__ + "assets/fonts/GothamRnd-Light.1549fe8f.otf";